/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const PAY_COSTUME_AND_TICKETS = gql`
  mutation PayCostumeAndTickets($data: PayCostumeAndTicketsInput!) {
    payCostumeAndTickets(data: $data) {
      txId
      session
      amount
      ticketAmount
      convenienceFee
      currency
      chargedAmount
      chargedCurrency
      totalCharged
      holdExpiresAt
    }
  }
`;
